module.exports = __webpack_public_path__ + "img/online_order.ff3cb3bc.png";